module.exports = __webpack_public_path__ + "static/media/005.5e8613a8.jpg";